export const getCurrentYearByFiscalVariant = (sapFiscalYearVariant, referenceDate = new Date()) => {
  const year = referenceDate.getFullYear();
  const month = referenceDate.getMonth() + 1;

  if (sapFiscalYearVariant === "13" || sapFiscalYearVariant === "32") {
    return month < 4 ? year - 1 : year;
  }

  if (sapFiscalYearVariant === "10") {
    return year;
  }

  return year;
};
